import React from 'react';

import { ProfileContext } from '../dataProvider';

import User from './User';

class Users extends React.PureComponent {
  render() {
    const { users } = this.props;
    return (
      <React.Fragment>
        <h3 className="heading heading--2">Профили</h3>
        <div className="spoilers">
          {users.map((user, index) => (
            <User key={`key-${user.id}`} user={user} isSelf={index === 0}  />
          ))}
        </div>
      </React.Fragment>
    );
  }
}

Users.contextType = ProfileContext;

export default Users;
